import BaseElement from './BaseElement'
import { AccountSlideout } from '../components/AccountSlideout'

export default class AccountSlideoutElement extends BaseElement {
  renderElement () {
    this.rootElement.render(<AccountSlideout children={this.firstElementChild} />)
  }
}
